import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withProps, compose } from 'recompose'

import { providesChannelMutations } from 'components/Channels/dataSync'
import { record as ChannelRecord } from 'data/channels'

import { makeToggleable } from 'components/Utils/toggleable'
import Confirm from 'components/Utils/Modal/Confirm'
import { Text } from 'components/base'

class Delete extends Component {
  render() {
    const {
      channel,
      deleteChannel,
      children,
      className,
      isModalOpen,
      openModal,
      closeModal,
    } = this.props
    return channel ? (
      <div className={`background-shade-100${className}`}>
        <Confirm
          show={isModalOpen}
          onConfirm={deleteChannel}
          onCancel={closeModal}
        >
          <div>
            <Text.Subtitle>This action cannot be undone.</Text.Subtitle>

            <Text.Corpus className="margin-vertical-large">
              Are you sure you want to delete the{' '}
              <span className="bold">{channel.name}</span> channel?
            </Text.Corpus>
          </div>
        </Confirm>
        <div onClick={openModal}>{children}</div>
      </div>
    ) : null
  }
}

const ConnectedDelete = compose(
  providesChannelMutations,
  makeToggleable({
    attrName: 'isModalOpen',
    toggleOnName: 'openModal',
    toggleOffName: 'closeModal',
    toggleName: 'toggleModal',
    defaultValue: false,
  }),
  withProps(({ deleteChannel, closeModal, onDelete, channel }) => ({
    deleteChannel: event => {
      closeModal(event)
      onDelete()
      deleteChannel({ id: channel.id })
    },
  }))
)(Delete)

ConnectedDelete.propTypes = {
  channel: PropTypes.instanceOf(ChannelRecord).isRequired,
  onDelete: PropTypes.func.isRequired,
}

ConnectedDelete.defaultProps = {
  onDelete: () => {},
}

export default ConnectedDelete
